import { __decorate, __metadata } from 'tslib';
import * as i5$1 from '@angular/common';
import { DOCUMENT, CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Injectable, Inject, forwardRef, Directive, Component, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import * as i3 from '@angular/router';
import { Router } from '@angular/router';
import { AutoSubscription } from '@upr-web-primer/app-utils';
import * as i4 from '@upr-web-primer/gds-common-utility';
import { GdsCommonUtilityService } from '@upr-web-primer/gds-common-utility';
import * as i1 from '@upr-web-primer/ms-guests';
import { MsGuestsService } from '@upr-web-primer/ms-guests';
import * as i5 from '@upr-web-primer/notification';
import { NotificationService } from '@upr-web-primer/notification';
import * as i2 from '@upr-web-primer/spinner';
import { SpinnerService } from '@upr-web-primer/spinner';
import { get, trimEnd } from 'lodash';
import { Subscription, BehaviorSubject, fromEvent } from 'rxjs';
import * as i1$1 from '@angular/forms';
import { NG_VALUE_ACCESSOR, FormControl, FormGroup, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GdsInputHelperDirective, gdsRequiredValidator, gdsMaxLengthValidator, gdsMinLengthValidator, gdsPatternValidator, NumberCharPattern } from '@upr-web-primer/gds-input-helper';
import * as i2$1 from '@upr-web-primer/form-fields';
import { FormControlService, FormFieldsModule } from '@upr-web-primer/form-fields';
import * as i4$1 from '@upr-web-primer/page-labels';
import { PageLabelsResolver } from '@upr-web-primer/page-labels';

let GdsInputFormService = class GdsInputFormService {
    constructor(document, msGuestService, spinner, router, commonUtilService, notification) {
        this.document = document;
        this.msGuestService = msGuestService;
        this.spinner = spinner;
        this.router = router;
        this.commonUtilService = commonUtilService;
        this.notification = notification;
        this.subscriptions = new Subscription();
        this.eventSubmit = new BehaviorSubject(0);
        this.eventSubmit$ = this.eventSubmit.asObservable();
        this.calloutFormLoaded = fromEvent(this.document, 'gdsCalloutFormContainerLoaded');
    }
    getServiceDetails(data) {
        const confirmationFields = data.confirmation;
        if (confirmationFields) {
            this.failureMessage = confirmationFields.failure_message;
            this.successMessage = confirmationFields.success_message;
            const redirectUrl = confirmationFields.redirection_url;
            this.redirectUrl = redirectUrl ? this.commonUtilService.resolveLinkUrl(redirectUrl) : redirectUrl;
            this.navigateAfterSuccess = ['true', true].includes(confirmationFields.navigate_after_submit);
        }
        this.sourceId = data.source_id;
    }
    renderInputForm(inputFormComponent) {
        let gdsCalloutFormContainer = document.querySelector('gds-callout-form-container');
        this.getServiceDetails(inputFormComponent.data);
        if (gdsCalloutFormContainer?.data) {
            this.setInputFormToCallout(inputFormComponent, gdsCalloutFormContainer);
        }
        if (!gdsCalloutFormContainer) {
            this.subscriptions.add(this.calloutFormLoaded.subscribe(() => {
                gdsCalloutFormContainer = document.querySelector('gds-callout-form-container');
                this.setInputFormToCallout(inputFormComponent, gdsCalloutFormContainer);
            }));
        }
    }
    setFormContainerData(formData) {
        const topComponentArticleDetail = {
            selector: 'gds-article-detail',
            data: { ...formData?.formdetail, hideGrid: true },
            meta: { type: 'left' },
        };
        const bottomComponentArticleDetail = {
            selector: 'gds-article-detail',
            data: { ...formData?.bottomformdetail, hideGrid: true },
            meta: { type: 'left' },
        };
        const data = {
            border: [true, 'true'].includes(formData?.border),
            topComponents: [topComponentArticleDetail],
            bottomComponents: [bottomComponentArticleDetail],
        };
        formData.data = data;
        return data;
    }
    setCalloutFormData(calloutFormComponent, backgroundColor) {
        const data = calloutFormComponent.data;
        calloutFormComponent.data = {
            backgroundColor: backgroundColor ?? '',
            components_right: data.components_right,
            components_left: [{
                    selector: 'gds-image-info-section',
                    data: {
                        components: [
                            {
                                selector: 'gds-avatar',
                                data: { image: data.avatarimage }
                            },
                            {
                                selector: 'gds-spacer',
                                meta: { classes: 'spacer-80' }
                            },
                            {
                                selector: 'gds-heading',
                                data: { heading: get(data, 'callouttext.headline', '') },
                                meta: { classes: 'heading-4' }
                            },
                            {
                                selector: 'gds-spacer',
                                meta: { classes: 'spacer-70' }
                            },
                            ...this.setListItemData(data)
                        ]
                    }
                }]
        };
    }
    setInputFormToCallout(inputFormComponent, gdsCalloutFormContainer) {
        const inputFormContainerData = this.setFormContainerData({ ...inputFormComponent.data });
        gdsCalloutFormContainer.data = {
            ...gdsCalloutFormContainer.data,
            components_right: [{
                    selector: 'gds-form-container', data: inputFormContainerData
                }]
        };
    }
    getHeaders() {
        const httpHeaders = this.msGuestService.helper.getNoCacheHeaders();
        const instanceId = this.msGuestService.helper.getInstanceId();
        if (!!instanceId) {
            httpHeaders['x-instance-id'] = instanceId;
        }
        if (!!this.sourceId) {
            httpHeaders['x-source-id'] = this.sourceId;
        }
        return httpHeaders;
    }
    setListItemData(calloutFormData) {
        const listItems = get(calloutFormData, 'callouttext.listItem', []);
        return listItems.flatMap((listItem) => {
            return [
                {
                    selector: 'gds-feature-icon-2',
                    data: {
                        svgOptions: {
                            iconName: listItem.icon,
                            width: 16.67,
                            height: 16.67
                        },
                        iconLabel: listItem.heading,
                        iconLabelStyle: 'heading-11'
                    }
                },
                {
                    selector: 'gds-spacer',
                    meta: { classes: 'spacer-70' }
                }
            ];
        });
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    submitFormData(data) {
        this.spinner.show();
        this.msGuestService.account.service.emailOptInOut(data, this.getHeaders()).then(() => {
            this.spinner.hide();
            if (this.navigateAfterSuccess) {
                this.router.navigate([this.redirectUrl]);
            }
            else {
                this.notification.show(this.successMessage, 'success');
                this.eventSubmit.next(true);
            }
        }).catch((error) => {
            this.spinner.hide();
            console.log(error);
            this.notification.show(this.failureMessage, 'error');
        });
    }
};
GdsInputFormService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsInputFormService, deps: [{ token: DOCUMENT }, { token: i1.MsGuestsService }, { token: i2.SpinnerService }, { token: i3.Router }, { token: i4.GdsCommonUtilityService }, { token: i5.NotificationService }], target: i0.ɵɵFactoryTarget.Injectable });
GdsInputFormService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsInputFormService, providedIn: 'root' });
GdsInputFormService = __decorate([
    AutoSubscription(),
    __metadata("design:paramtypes", [Object, MsGuestsService,
        SpinnerService,
        Router,
        GdsCommonUtilityService,
        NotificationService])
], GdsInputFormService);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsInputFormService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: i1.MsGuestsService }, { type: i2.SpinnerService }, { type: i3.Router }, { type: i4.GdsCommonUtilityService }, { type: i5.NotificationService }]; } });

const gdsInputTypes = [
    'text',
    'textarea',
    'checkbox',
    'date',
    'password',
    'number',
    'date',
    'time',
    'month',
    'week',
    'tel',
    'range',
    'reset',
    'url',
    'search',
    'datetime',
    'color',
    'file',
];
const gdsButtonTypes = ['primary', 'secondary', 'tertiary', 'tertiary-small'];
const specialGdsInputTypes = ['radio', 'select'];
const gdsFormFieldTypes = [
    'firstName',
    'lastName',
    'suffix',
    'phoneNumber',
    'dateOfBirth',
    'email',
    'country',
    'state',
    'zip',
];
const gdsFormElementTypes = [
    'maxCharacterCount',
    'characterCountThreshold',
    'cols',
    'rows',
];
const unsubscribePrefix = '_UNSUBSCRIBE';
const isOptInOutTypes = (type) => {
    return type?.includes('_EMAIL_OFFERS');
};
const isFieldToDelete = (type) => {
    return type === 'delete_field_on_submit';
};
const createFormData = (formData, checkBoxFields, optInOutMap, fieldsToDelete) => {
    const opt_in_out = [];
    const result = {};
    let optOutExists = false;
    Object.keys(formData).forEach((field) => {
        if (!fieldsToDelete.includes(field)) {
            result[field] = formData[field];
            if (checkBoxFields.includes(field)) {
                result[field] = result[field] === 'checked';
            }
            if (optInOutMap[field]) {
                const isUnsubscribe = optInOutMap[field].includes(unsubscribePrefix);
                if (isUnsubscribe && !optOutExists) {
                    optOutExists = true;
                }
                opt_in_out.push({
                    type: isUnsubscribe ? optInOutMap[field].replace(unsubscribePrefix, '') : optInOutMap[field],
                    opt_in: isUnsubscribe && result[field] ? false : result[field]
                });
                delete result[field];
            }
            if (optOutExists) {
                if (result.email_offers_promos) {
                    result.email_offers_promos = false;
                }
                if (result.email_offers_promos_ush) {
                    result.email_offers_promos_ush = false;
                }
            }
        }
    });
    return { ...result, opt_in_out };
};

class GdsInputFormCvaDirective extends GdsInputHelperDirective {
}
GdsInputFormCvaDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsInputFormCvaDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
GdsInputFormCvaDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.11", type: GdsInputFormCvaDirective, selector: "gds-input, gds-dropdown", providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => GdsInputFormCvaDirective),
            multi: true
        }
    ], usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsInputFormCvaDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'gds-input, gds-dropdown',
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => GdsInputFormCvaDirective),
                            multi: true
                        }
                    ]
                }]
        }] });

let GdsInputFormComponent = class GdsInputFormComponent {
    constructor(fb, document, formControlService, inputFormService, pageLabelsResolver) {
        this.fb = fb;
        this.document = document;
        this.formControlService = formControlService;
        this.inputFormService = inputFormService;
        this.pageLabelsResolver = pageLabelsResolver;
        this.gdsInputTypes = gdsInputTypes;
        this.theme = 'theme-default';
        this.selectedCountry = '';
        this.isZipCodeManditory = true;
        this.formDataReady = false;
        this.disableInvalidSubmitButton = false;
        this.radioGroups = [];
        this.isUsCountry = true;
        this.countryLabel = '';
        this.checkBoxFields = [];
        this.fieldsToDelete = [];
        this.formOptInOutMap = {};
        this.inputFormService.eventSubmit$.subscribe(event => {
            if (event) {
                this.clearFormValues();
            }
        });
    }
    ngOnInit() { }
    initForm(formData, pageLabels) {
        this.sampleForm = this.fb.group({});
        this.checkBoxFields = [];
        this.fieldsToDelete = [];
        this.formOptInOutMap = {};
        this.initFormData = formData;
        if (!pageLabels) {
            this.pageLabelsResolver.get().then((pageLabels) => {
                this.pageLabels = pageLabels;
                this.setFormElements(formData);
            });
        }
        else {
            this.pageLabels = pageLabels;
            this.setFormElements(formData);
        }
    }
    setFormElements(formData) {
        this.formControlService.pageLabels = this.pageLabels;
        this.theme = get(formData, 'theme', 'theme-default');
        this.formControls = this.formControlService;
        this.nameControls = this.formControls.nameControls;
        this.suffixControl = this.formControls.suffixControl;
        this.addressControls = this.formControls.addressControls;
        this.phoneControl = this.formControls.phoneControl;
        this.emailControl = this.formControls.emailControl;
        this.dateOfBirthControl = this.formControls.dateOfBirthControl;
        const fields = [...get(formData, 'data.sections.fields', [])];
        if (!fields?.length) {
            return;
        }
        this.formElements = fields.flatMap((formElement) => {
            const { field } = formElement;
            field.name = field.name?.trim();
            field.required = [true, 'true'].includes(field.required);
            if (field.type === 'checkbox') {
                this.checkBoxFields.push(field.name);
            }
            if (isFieldToDelete(field.action)) {
                this.fieldsToDelete.push(field.name);
            }
            if (isOptInOutTypes(field.action)) {
                this.formOptInOutMap[field.name] = field.action;
            }
            if (gdsInputTypes.includes(field.type) && field.name) {
                this.setFormControlElement(field);
                return this.setInputData(field);
            }
            else if (field.type === 'select') {
                this.setFormControlElement(field);
                return this.setDropdownData(field);
            }
            else if (field.type === 'radio') {
                return [...this.setRadioData(field)];
            }
            else if (gdsFormFieldTypes.includes(field.type)) {
                return this.setFormFieldData(field);
            }
            else if (gdsButtonTypes.includes(field.type)) {
                return this.setButtonData(field);
            }
            return field;
        });
        this.formDataReady = true;
    }
    setFormFieldData(formElement) {
        let controls;
        switch (formElement.type) {
            case 'firstName':
                controls = this.nameControls[0];
                break;
            case 'lastName':
                controls = this.nameControls[1];
                break;
            case 'suffix':
                controls = this.suffixControl;
                break;
            case 'phoneNumber':
                controls = this.phoneControl;
                break;
            case 'email':
                controls = this.emailControl;
                break;
            case 'dateOfBirth':
                controls = this.dateOfBirthControl;
                break;
            case 'country':
                controls = this.addressControls[0];
                break;
            case 'state':
                controls = this.addressControls[5];
                break;
            case 'zip':
                controls = this.addressControls[3];
                break;
            default:
                controls = {};
                break;
        }
        const { label = '', supportingText = '', tooltip = '', placeholder = '', value = '' } = formElement;
        return {
            ...controls,
            ...formElement,
            data: {
                ...controls,
                ...formElement,
                label,
                supportingText,
                tooltip,
                placeholder,
                value,
            },
        };
    }
    setInputData(formElement) {
        for (const property in formElement) {
            const propertyValue = formElement[property];
            if (gdsFormElementTypes.includes(property) &&
                propertyValue &&
                Array.isArray(propertyValue) &&
                propertyValue[0]) {
                formElement[property] = Number(propertyValue[0]);
            }
        }
        return {
            ...formElement,
            data: {
                ...formElement,
                primaryLabel: formElement.label ?? '',
                supportingText: formElement.supportingText ?? '',
                placeholder: formElement.placeholder ?? '',
            },
        };
    }
    setDropdownData(formElement) {
        return {
            ...formElement,
            data: {
                formField: {
                    primaryLabel: formElement.label,
                    supportingText: formElement.supportingText,
                    tooltip: formElement.tooltip,
                },
                options: formElement.options.map((option) => {
                    return {
                        label: option,
                        value: option,
                    };
                }),
                placeholder: formElement.placeholder,
            },
        };
    }
    setRadioData(formElement) {
        this.setFormControlElement(formElement);
        return formElement.options.map((option) => {
            return {
                ...formElement,
                data: {
                    primaryLabel: option,
                    value: option,
                    name: formElement.name,
                    default: (formElement.value && formElement.value === option),
                },
            };
        });
    }
    setButtonData(formElement) {
        return {
            type: 'button',
            data: formElement,
        };
    }
    getGdsInputType(formElement) {
        return gdsInputTypes.includes(formElement.type) ||
            formElement.type === 'radio'
            ? formElement.type
            : '';
    }
    getGdsInputValue(formElement) {
        return formElement.type === 'radio'
            ? formElement.data.value
            : this.sampleForm?.controls[formElement.name]?.value;
    }
    getValidators(formElement) {
        const validations = Array.isArray(formElement.validations) ? formElement.validations : [formElement.validations];
        const validators = [];
        if (formElement.required) {
            validators.push(gdsRequiredValidator(this.pageLabels.ER26));
            formElement.label = trimEnd(formElement.label, '*').trim();
            formElement.label = `${formElement.label}*`;
        }
        if (gdsInputTypes.includes(formElement.type) && validations.length) {
            validations.forEach((validation) => {
                const fieldValidator = get(validation, 'fieldValidator', false);
                const condition = get(validation, 'condition', false);
                if (!fieldValidator || validation.fieldValidator === '-')
                    return;
                if (fieldValidator === "MaxLength" && condition) {
                    const maxLength = validation.condition;
                    validators.push(gdsMaxLengthValidator(Number(maxLength), this.pageLabels.maxLengthError));
                }
                if (fieldValidator === "MinLength" && condition) {
                    const minLength = validation.condition;
                    validators.push(gdsMinLengthValidator(Number(minLength), this.pageLabels.minLengthError));
                }
                if (fieldValidator === "NoSpecialCharacters") {
                    validators.push(gdsPatternValidator(NumberCharPattern.NO_SPECIAL_CHARS, this.pageLabels.ER12));
                }
            });
        }
        return validators;
    }
    setFormControlElement(formElement) {
        this.addFormControl(formElement.name.trim(), new FormControl(formElement.value ?? '', this.getValidators(formElement)));
    }
    addFormControl(name, formControl, formGroupName) {
        const formGroup = this.getFormGroup(formGroupName);
        if (formGroup?.get(name)) {
            formGroup.removeControl(name);
        }
        formGroup?.addControl(name, formControl);
    }
    removeFormControls(controlNames) {
        const names = Array.isArray(controlNames) ? controlNames : [controlNames];
        names.forEach((name) => {
            if (this.sampleForm.get(name)) {
                this.sampleForm.removeControl(name);
            }
        });
    }
    getFormGroup(name) {
        return name ? this.sampleForm.get(name) : this.sampleForm;
    }
    getFormControl(name) {
        return this.sampleForm.controls[name];
    }
    onCountryChange(country, action) {
        if (action === 'remove-zipcode-on-non-US-country') {
            if (country === 'US' && this.selectedCountry !== 'US') {
                if (this.selectedCountry) {
                    this.countryLabel = "State and zip code sections added.";
                }
                this.isUsCountry = true;
            }
            else if (country !== 'US' && this.selectedCountry === 'US') {
                this.countryLabel = "State and zip code sections removed.";
                this.isUsCountry = false;
                const zipCode = this.formElements.find(f => f.type === 'zip')?.name;
                const stateCode = this.formElements.find(f => f.type === 'state')?.name;
                this.removeFormControls([zipCode, stateCode]);
            }
        }
        this.selectedCountry = country;
    }
    validateAllFormFields(formGroup) {
        const firstInvalidControl = this.recursivelyMarkControlsAsTouched(formGroup);
        if (firstInvalidControl) {
            this.focusOnControl(firstInvalidControl);
        }
    }
    recursivelyMarkControlsAsTouched(formGroup) {
        let firstInvalidControl = null;
        const parentControls = formGroup.controls;
        for (const formElement of this.formElements) {
            const { name } = formElement;
            if (parentControls.hasOwnProperty(name)) {
                const control = parentControls[name];
                if (control instanceof FormControl) {
                    this.validateFormControl(control);
                    if (control.invalid && !firstInvalidControl) {
                        firstInvalidControl = control;
                    }
                }
                else if (control instanceof FormGroup) {
                    const childInvalidControl = this.recursivelyMarkControlsAsTouched(control);
                    if (childInvalidControl && !firstInvalidControl) {
                        firstInvalidControl = childInvalidControl;
                    }
                }
            }
        }
        return firstInvalidControl;
    }
    validateFormControl(control) {
        control?.markAsTouched({ onlySelf: true });
        control?.setValue(control?.value);
    }
    focusOnControl(control) {
        const parent = control?.parent;
        if (parent) {
            const controlName = Object.keys(parent.controls).find(name => parent.get(name) === control);
            const inputElement = this.document.querySelector(`#${controlName} input, #${controlName} select, #${controlName} textarea, #${controlName} gds-dropdown-control`);
            if (inputElement) {
                inputElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }
    }
    fieldValueChange(value, controlName) {
        this.getFormControl(controlName).setValue(value);
    }
    fieldBlurChange(controlName) {
        this.getFormControl(controlName).markAsTouched();
    }
    gdsButtonClicked(action) {
        if (action === 'udx_form_submit' && this.isFormValid()) {
            const formData = createFormData(this.sampleForm.value, this.checkBoxFields, this.formOptInOutMap, this.fieldsToDelete);
            this.inputFormService.submitFormData(formData);
        }
    }
    isFormValid() {
        this.validateAllFormFields(this.sampleForm);
        return this.sampleForm.valid;
    }
    clearFormValues() {
        this.initForm(this.initFormData, this.pageLabels);
    }
    ngOnDestroy() {
    }
};
GdsInputFormComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsInputFormComponent, deps: [{ token: i1$1.FormBuilder }, { token: DOCUMENT }, { token: i2$1.FormControlService }, { token: GdsInputFormService }, { token: i4$1.PageLabelsResolver }], target: i0.ɵɵFactoryTarget.Component });
GdsInputFormComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: GdsInputFormComponent, selector: "upr-gds-input-form", ngImport: i0, template: "<ng-container #gdsInputFormElem>\r\n\t<div *ngIf=\"formDataReady\">\r\n\t\t<div slot=\"gds-form\" [formGroup]=\"sampleForm\">\r\n\t\t\t<ng-container *ngFor=\"let formElement of formElements\">\r\n\t\t\t\t<ng-container [ngSwitch]=\"formElement.type\">\r\n\t\t\t\t\t<!-- Generic Input -->\r\n\t\t\t\t\t<gds-input\r\n\t\t\t\t\t\t*ngSwitchCase=\"\r\n\t\t\t\t\t\t\tgdsInputTypes.includes(formElement.type) ? formElement.type : ''\r\n\t\t\t\t\t\t\"\r\n\t\t\t\t\t\t[formControlName]=\"formElement.name\"\r\n\t\t\t\t\t\t[theme]=\"theme\"\r\n\t\t\t\t\t\t[data]=\"formElement.data\"\r\n\t\t\t\t\t\t[type]=\"formElement.type\"\r\n\t\t\t\t\t\t[id]=\"formElement.name\"\r\n\t\t\t\t\t\t[value]=\"sampleForm?.controls[formElement.name]?.value\"\r\n\t\t\t\t\t\t[errors]=\"sampleForm?.controls[formElement.name]?.errors?.message\"\r\n\t\t\t\t\t></gds-input>\r\n\r\n\t\t\t\t\t<!-- Generic Dropdown -->\r\n\t\t\t\t\t<gds-dropdown\r\n\t\t\t\t\t\t*ngSwitchCase=\"'select'\"\r\n\t\t\t\t\t\t[formControlName]=\"formElement.name\"\r\n\t\t\t\t\t\t[theme]=\"theme\"\r\n\t\t\t\t\t\t[data]=\"formElement.data\"\r\n\t\t\t\t\t\t[id]=\"formElement.name\"\r\n\t\t\t\t\t\t[isNative]=\"formElement.isNative ?? false\"\r\n\t\t\t\t\t\t[value]=\"sampleForm?.controls[formElement.name]?.value\"\r\n\t\t\t\t\t\t[errorMessage]=\"\r\n\t\t\t\t\t\t\tsampleForm?.controls[formElement.name]?.errors?.message\r\n\t\t\t\t\t\t\"\r\n\t\t\t\t\t></gds-dropdown>\r\n\r\n\t\t\t\t\t<!-- Radio -->\r\n\t\t\t\t\t<gds-input\r\n\t\t\t\t\t\t*ngSwitchCase=\"'radio'\"\r\n\t\t\t\t\t\t[theme]=\"theme\"\r\n\t\t\t\t\t\t[data]=\"formElement.data\"\r\n\t\t\t\t\t\t[type]=\"formElement.type\"\r\n\t\t\t\t\t\t[id]=\"formElement.name\"\r\n\t\t\t\t\t\t[value]=\"formElement.data.value\"\r\n\t\t\t\t\t\t[errors]=\"sampleForm?.controls[formElement.name]?.errors?.message\"\r\n\t\t\t\t\t\t(valueChange)=\"fieldValueChange($event.detail, formElement.name)\"\r\n\t\t\t\t\t\t(blurChange)=\"fieldBlurChange(formElement.name)\"\r\n\t\t\t\t\t></gds-input>\r\n\r\n\t\t\t\t\t<!-- First Name -->\r\n\t\t\t\t\t<upr-gds-name-field\r\n\t\t\t\t\t\t*ngSwitchCase=\"'firstName'\"\r\n\t\t\t\t\t\t[id]=\"formElement.name\"\r\n\t\t\t\t\t\t(formReady)=\"addFormControl(formElement.name, $event)\"\r\n\t\t\t\t\t\t[formData]=\"formElement.data\"\r\n\t\t\t\t\t\t[theme]=\"theme\"\r\n\t\t\t\t\t>\r\n\t\t\t\t\t</upr-gds-name-field>\r\n\r\n\t\t\t\t\t<!-- Last Name -->\r\n\t\t\t\t\t<upr-gds-name-field\r\n\t\t\t\t\t\t*ngSwitchCase=\"'lastName'\"\r\n\t\t\t\t\t\t[id]=\"formElement.name\"\r\n\t\t\t\t\t\t(formReady)=\"addFormControl(formElement.name, $event)\"\r\n\t\t\t\t\t\t[formData]=\"formElement.data\"\r\n\t\t\t\t\t\t[theme]=\"theme\"\r\n\t\t\t\t\t>\r\n\t\t\t\t\t</upr-gds-name-field>\r\n\r\n\t\t\t\t\t<!-- Suffix -->\r\n\t\t\t\t\t<upr-gds-name-field\r\n\t\t\t\t\t\t*ngSwitchCase=\"'suffix'\"\r\n\t\t\t\t\t\t[id]=\"formElement.name\"\r\n\t\t\t\t\t\t(formReady)=\"addFormControl(formElement.name, $event)\"\r\n\t\t\t\t\t\t[formData]=\"formElement.data\"\r\n\t\t\t\t\t\t[theme]=\"theme\"\r\n\t\t\t\t\t>\r\n\t\t\t\t\t</upr-gds-name-field>\r\n\r\n\t\t\t\t\t<!-- Phone Number -->\r\n\t\t\t\t\t<upr-gds-phone-field\r\n\t\t\t\t\t\t*ngSwitchCase=\"'phoneNumber'\"\r\n\t\t\t\t\t\t[id]=\"formElement.name\"\r\n\t\t\t\t\t\t(formReady)=\"addFormControl(formElement.name, $event)\"\r\n\t\t\t\t\t\t[formData]=\"formElement.data\"\r\n\t\t\t\t\t\t[countryName]=\"selectedCountry\"\r\n\t\t\t\t\t\t[theme]=\"theme\"\r\n\t\t\t\t\t>\r\n\t\t\t\t\t</upr-gds-phone-field>\r\n\r\n\t\t\t\t\t<!-- Email -->\r\n\t\t\t\t\t<upr-gds-email-field\r\n\t\t\t\t\t\t*ngSwitchCase=\"'email'\"\r\n\t\t\t\t\t\t[id]=\"formElement.name\"\r\n\t\t\t\t\t\t(formReady)=\"addFormControl(formElement.name, $event)\"\r\n\t\t\t\t\t\t[formData]=\"formElement.data\"\r\n\t\t\t\t\t\t[theme]=\"theme\"\r\n\t\t\t\t\t></upr-gds-email-field>\r\n\r\n\t\t\t\t\t<!-- Date of Birth -->\r\n\t\t\t\t\t<upr-gds-dob-field\r\n\t\t\t\t\t\t*ngSwitchCase=\"'dateOfBirth'\"\r\n\t\t\t\t\t\t[id]=\"formElement.name\"\r\n\t\t\t\t\t\t(formReady)=\"addFormControl(formElement.name, $event)\"\r\n\t\t\t\t\t\t[formData]=\"formElement.data\"\r\n\t\t\t\t\t\t[theme]=\"theme\"\r\n\t\t\t\t\t></upr-gds-dob-field>\r\n\r\n\t\t\t\t\t<!-- Country -->\r\n\t\t\t\t\t<upr-gds-address-field\r\n\t\t\t\t\t\t*ngSwitchCase=\"'country'\"\r\n\t\t\t\t\t\t[id]=\"formElement.name\"\r\n\t\t\t\t\t\t(formReady)=\"addFormControl(formElement.name, $event)\"\r\n\t\t\t\t\t\t(countryChange)=\"onCountryChange($event, formElement.data.action)\"\r\n\t\t\t\t\t\t[country]=\"selectedCountry\"\r\n\t\t\t\t\t\t[state]=\"selectedState\"\r\n\t\t\t\t\t\t[formData]=\"formElement.data\"\r\n\t\t\t\t\t\t[isZipCodeMandiory]=\"isZipCodeManditory\"\r\n\t\t\t\t\t\t[useNativeStateDropdown]=\"true\"\r\n\t\t\t\t\t\t[theme]=\"theme\"\r\n\t\t\t\t\t>\r\n\t\t\t\t\t</upr-gds-address-field>\r\n\r\n\t\t\t\t\t<div\r\n\t\t\t\t\t\t*ngSwitchCase=\"'country'\"\r\n\t\t\t\t\t\trole=\"region\"\r\n\t\t\t\t\t\taria-live=\"polite\"\r\n\t\t\t\t\t\tclass=\"sr-only\"\r\n\t\t\t\t\t\t[innerHTML]=\"countryLabel\"\r\n\t\t\t\t\t></div>\r\n\r\n\t\t\t\t\t<!-- State -->\r\n\t\t\t\t\t<ng-container *ngSwitchCase=\"'state'\">\r\n\t\t\t\t\t\t<upr-gds-address-field\r\n\t\t\t\t\t\t\t*ngIf=\"isUsCountry\"\r\n\t\t\t\t\t\t\t[id]=\"formElement.name\"\r\n\t\t\t\t\t\t\t(formReady)=\"addFormControl(formElement.name, $event)\"\r\n\t\t\t\t\t\t\t[country]=\"selectedCountry\"\r\n\t\t\t\t\t\t\t[state]=\"selectedState\"\r\n\t\t\t\t\t\t\t[formData]=\"formElement.data\"\r\n\t\t\t\t\t\t\t[isZipCodeMandiory]=\"isZipCodeManditory\"\r\n\t\t\t\t\t\t\t[useNativeStateDropdown]=\"true\"\r\n\t\t\t\t\t\t\t[theme]=\"theme\"\r\n\t\t\t\t\t\t>\r\n\t\t\t\t\t\t</upr-gds-address-field>\r\n\t\t\t\t\t\t<gds-spacer classes=\"spacer-50\" *ngIf=\"isUsCountry\"></gds-spacer>\r\n\t\t\t\t\t</ng-container>\r\n\r\n\t\t\t\t\t<!-- Zip -->\r\n\t\t\t\t\t<ng-container *ngSwitchCase=\"'zip'\">\r\n\t\t\t\t\t\t<upr-gds-address-field\r\n\t\t\t\t\t\t\t*ngIf=\"isUsCountry\"\r\n\t\t\t\t\t\t\t[id]=\"formElement.name\"\r\n\t\t\t\t\t\t\t(formReady)=\"addFormControl(formElement.name, $event)\"\r\n\t\t\t\t\t\t\t[country]=\"selectedCountry\"\r\n\t\t\t\t\t\t\t[state]=\"selectedState\"\r\n\t\t\t\t\t\t\t[formData]=\"formElement.data\"\r\n\t\t\t\t\t\t\t[isZipCodeMandiory]=\"formElement.required\"\r\n\t\t\t\t\t\t\t[useNativeStateDropdown]=\"true\"\r\n\t\t\t\t\t\t\t[theme]=\"theme\"\r\n\t\t\t\t\t\t>\r\n\t\t\t\t\t\t</upr-gds-address-field>\r\n\t\t\t\t\t\t<gds-spacer classes=\"spacer-50\" *ngIf=\"isUsCountry\"></gds-spacer>\r\n\t\t\t\t\t</ng-container>\r\n\r\n\t\t\t\t\t<!-- Button -->\r\n\t\t\t\t\t<gds-button\r\n\t\t\t\t\t\t*ngSwitchCase=\"'button'\"\r\n\t\t\t\t\t\t[theme]=\"theme\"\r\n\t\t\t\t\t\t[data]=\"formElement.data\"\r\n\t\t\t\t\t\t[id]=\"formElement.name\"\r\n\t\t\t\t\t\t(buttonClicked)=\"gdsButtonClicked(formElement.data.action)\"\r\n\t\t\t\t\t></gds-button>\r\n\r\n\t\t\t\t\t<!-- Spacer -->\r\n\t\t\t\t\t<gds-spacer\r\n\t\t\t\t\t\tclasses=\"spacer-50\"\r\n\t\t\t\t\t\t*ngIf=\"formElement.type !== 'state' && formElement.type !== 'zip'\"\r\n\t\t\t\t\t></gds-spacer>\r\n\t\t\t\t</ng-container>\r\n\t\t\t</ng-container>\r\n\t\t</div>\r\n\t</div>\r\n</ng-container>\r\n", styles: [".sr-only{position:absolute;width:1px;height:1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;clip-path:inset(50%);border:0}\n"], components: [{ type: i2$1.GdsNameFieldComponent, selector: "upr-gds-name-field", inputs: ["formData", "formDataValue", "theme"], outputs: ["formReady"] }, { type: i2$1.GdsPhoneFieldComponent, selector: "upr-gds-phone-field", inputs: ["formData", "countryName", "formDataValue", "minLength", "pattern", "theme"], outputs: ["formReady"] }, { type: i2$1.GdsEmailFieldComponent, selector: "upr-gds-email-field", inputs: ["formData", "formDataValue", "pattern", "theme"], outputs: ["formReady"] }, { type: i2$1.GdsDobFieldComponent, selector: "upr-gds-dob-field", inputs: ["formData", "formDataValue", "pattern", "theme"], outputs: ["formReady"] }, { type: i2$1.GdsAddressFieldComponent, selector: "upr-gds-address-field", inputs: ["formData", "formDataValue", "country", "state", "isAddressComponent", "isZipCodeMandiory", "optionalLabel", "displayedInModal", "useNativeStateDropdown", "isCoBrandCard", "theme"], outputs: ["formReady", "countryChange", "stateChange"] }], directives: [{ type: i5$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i1$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i5$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i5$1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { type: i5$1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { type: GdsInputFormCvaDirective, selector: "gds-input, gds-dropdown" }, { type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1$1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }] });
GdsInputFormComponent = __decorate([
    AutoSubscription(),
    __metadata("design:paramtypes", [FormBuilder,
        Document,
        FormControlService,
        GdsInputFormService,
        PageLabelsResolver])
], GdsInputFormComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsInputFormComponent, decorators: [{
            type: Component,
            args: [{ selector: 'upr-gds-input-form', template: "<ng-container #gdsInputFormElem>\r\n\t<div *ngIf=\"formDataReady\">\r\n\t\t<div slot=\"gds-form\" [formGroup]=\"sampleForm\">\r\n\t\t\t<ng-container *ngFor=\"let formElement of formElements\">\r\n\t\t\t\t<ng-container [ngSwitch]=\"formElement.type\">\r\n\t\t\t\t\t<!-- Generic Input -->\r\n\t\t\t\t\t<gds-input\r\n\t\t\t\t\t\t*ngSwitchCase=\"\r\n\t\t\t\t\t\t\tgdsInputTypes.includes(formElement.type) ? formElement.type : ''\r\n\t\t\t\t\t\t\"\r\n\t\t\t\t\t\t[formControlName]=\"formElement.name\"\r\n\t\t\t\t\t\t[theme]=\"theme\"\r\n\t\t\t\t\t\t[data]=\"formElement.data\"\r\n\t\t\t\t\t\t[type]=\"formElement.type\"\r\n\t\t\t\t\t\t[id]=\"formElement.name\"\r\n\t\t\t\t\t\t[value]=\"sampleForm?.controls[formElement.name]?.value\"\r\n\t\t\t\t\t\t[errors]=\"sampleForm?.controls[formElement.name]?.errors?.message\"\r\n\t\t\t\t\t></gds-input>\r\n\r\n\t\t\t\t\t<!-- Generic Dropdown -->\r\n\t\t\t\t\t<gds-dropdown\r\n\t\t\t\t\t\t*ngSwitchCase=\"'select'\"\r\n\t\t\t\t\t\t[formControlName]=\"formElement.name\"\r\n\t\t\t\t\t\t[theme]=\"theme\"\r\n\t\t\t\t\t\t[data]=\"formElement.data\"\r\n\t\t\t\t\t\t[id]=\"formElement.name\"\r\n\t\t\t\t\t\t[isNative]=\"formElement.isNative ?? false\"\r\n\t\t\t\t\t\t[value]=\"sampleForm?.controls[formElement.name]?.value\"\r\n\t\t\t\t\t\t[errorMessage]=\"\r\n\t\t\t\t\t\t\tsampleForm?.controls[formElement.name]?.errors?.message\r\n\t\t\t\t\t\t\"\r\n\t\t\t\t\t></gds-dropdown>\r\n\r\n\t\t\t\t\t<!-- Radio -->\r\n\t\t\t\t\t<gds-input\r\n\t\t\t\t\t\t*ngSwitchCase=\"'radio'\"\r\n\t\t\t\t\t\t[theme]=\"theme\"\r\n\t\t\t\t\t\t[data]=\"formElement.data\"\r\n\t\t\t\t\t\t[type]=\"formElement.type\"\r\n\t\t\t\t\t\t[id]=\"formElement.name\"\r\n\t\t\t\t\t\t[value]=\"formElement.data.value\"\r\n\t\t\t\t\t\t[errors]=\"sampleForm?.controls[formElement.name]?.errors?.message\"\r\n\t\t\t\t\t\t(valueChange)=\"fieldValueChange($event.detail, formElement.name)\"\r\n\t\t\t\t\t\t(blurChange)=\"fieldBlurChange(formElement.name)\"\r\n\t\t\t\t\t></gds-input>\r\n\r\n\t\t\t\t\t<!-- First Name -->\r\n\t\t\t\t\t<upr-gds-name-field\r\n\t\t\t\t\t\t*ngSwitchCase=\"'firstName'\"\r\n\t\t\t\t\t\t[id]=\"formElement.name\"\r\n\t\t\t\t\t\t(formReady)=\"addFormControl(formElement.name, $event)\"\r\n\t\t\t\t\t\t[formData]=\"formElement.data\"\r\n\t\t\t\t\t\t[theme]=\"theme\"\r\n\t\t\t\t\t>\r\n\t\t\t\t\t</upr-gds-name-field>\r\n\r\n\t\t\t\t\t<!-- Last Name -->\r\n\t\t\t\t\t<upr-gds-name-field\r\n\t\t\t\t\t\t*ngSwitchCase=\"'lastName'\"\r\n\t\t\t\t\t\t[id]=\"formElement.name\"\r\n\t\t\t\t\t\t(formReady)=\"addFormControl(formElement.name, $event)\"\r\n\t\t\t\t\t\t[formData]=\"formElement.data\"\r\n\t\t\t\t\t\t[theme]=\"theme\"\r\n\t\t\t\t\t>\r\n\t\t\t\t\t</upr-gds-name-field>\r\n\r\n\t\t\t\t\t<!-- Suffix -->\r\n\t\t\t\t\t<upr-gds-name-field\r\n\t\t\t\t\t\t*ngSwitchCase=\"'suffix'\"\r\n\t\t\t\t\t\t[id]=\"formElement.name\"\r\n\t\t\t\t\t\t(formReady)=\"addFormControl(formElement.name, $event)\"\r\n\t\t\t\t\t\t[formData]=\"formElement.data\"\r\n\t\t\t\t\t\t[theme]=\"theme\"\r\n\t\t\t\t\t>\r\n\t\t\t\t\t</upr-gds-name-field>\r\n\r\n\t\t\t\t\t<!-- Phone Number -->\r\n\t\t\t\t\t<upr-gds-phone-field\r\n\t\t\t\t\t\t*ngSwitchCase=\"'phoneNumber'\"\r\n\t\t\t\t\t\t[id]=\"formElement.name\"\r\n\t\t\t\t\t\t(formReady)=\"addFormControl(formElement.name, $event)\"\r\n\t\t\t\t\t\t[formData]=\"formElement.data\"\r\n\t\t\t\t\t\t[countryName]=\"selectedCountry\"\r\n\t\t\t\t\t\t[theme]=\"theme\"\r\n\t\t\t\t\t>\r\n\t\t\t\t\t</upr-gds-phone-field>\r\n\r\n\t\t\t\t\t<!-- Email -->\r\n\t\t\t\t\t<upr-gds-email-field\r\n\t\t\t\t\t\t*ngSwitchCase=\"'email'\"\r\n\t\t\t\t\t\t[id]=\"formElement.name\"\r\n\t\t\t\t\t\t(formReady)=\"addFormControl(formElement.name, $event)\"\r\n\t\t\t\t\t\t[formData]=\"formElement.data\"\r\n\t\t\t\t\t\t[theme]=\"theme\"\r\n\t\t\t\t\t></upr-gds-email-field>\r\n\r\n\t\t\t\t\t<!-- Date of Birth -->\r\n\t\t\t\t\t<upr-gds-dob-field\r\n\t\t\t\t\t\t*ngSwitchCase=\"'dateOfBirth'\"\r\n\t\t\t\t\t\t[id]=\"formElement.name\"\r\n\t\t\t\t\t\t(formReady)=\"addFormControl(formElement.name, $event)\"\r\n\t\t\t\t\t\t[formData]=\"formElement.data\"\r\n\t\t\t\t\t\t[theme]=\"theme\"\r\n\t\t\t\t\t></upr-gds-dob-field>\r\n\r\n\t\t\t\t\t<!-- Country -->\r\n\t\t\t\t\t<upr-gds-address-field\r\n\t\t\t\t\t\t*ngSwitchCase=\"'country'\"\r\n\t\t\t\t\t\t[id]=\"formElement.name\"\r\n\t\t\t\t\t\t(formReady)=\"addFormControl(formElement.name, $event)\"\r\n\t\t\t\t\t\t(countryChange)=\"onCountryChange($event, formElement.data.action)\"\r\n\t\t\t\t\t\t[country]=\"selectedCountry\"\r\n\t\t\t\t\t\t[state]=\"selectedState\"\r\n\t\t\t\t\t\t[formData]=\"formElement.data\"\r\n\t\t\t\t\t\t[isZipCodeMandiory]=\"isZipCodeManditory\"\r\n\t\t\t\t\t\t[useNativeStateDropdown]=\"true\"\r\n\t\t\t\t\t\t[theme]=\"theme\"\r\n\t\t\t\t\t>\r\n\t\t\t\t\t</upr-gds-address-field>\r\n\r\n\t\t\t\t\t<div\r\n\t\t\t\t\t\t*ngSwitchCase=\"'country'\"\r\n\t\t\t\t\t\trole=\"region\"\r\n\t\t\t\t\t\taria-live=\"polite\"\r\n\t\t\t\t\t\tclass=\"sr-only\"\r\n\t\t\t\t\t\t[innerHTML]=\"countryLabel\"\r\n\t\t\t\t\t></div>\r\n\r\n\t\t\t\t\t<!-- State -->\r\n\t\t\t\t\t<ng-container *ngSwitchCase=\"'state'\">\r\n\t\t\t\t\t\t<upr-gds-address-field\r\n\t\t\t\t\t\t\t*ngIf=\"isUsCountry\"\r\n\t\t\t\t\t\t\t[id]=\"formElement.name\"\r\n\t\t\t\t\t\t\t(formReady)=\"addFormControl(formElement.name, $event)\"\r\n\t\t\t\t\t\t\t[country]=\"selectedCountry\"\r\n\t\t\t\t\t\t\t[state]=\"selectedState\"\r\n\t\t\t\t\t\t\t[formData]=\"formElement.data\"\r\n\t\t\t\t\t\t\t[isZipCodeMandiory]=\"isZipCodeManditory\"\r\n\t\t\t\t\t\t\t[useNativeStateDropdown]=\"true\"\r\n\t\t\t\t\t\t\t[theme]=\"theme\"\r\n\t\t\t\t\t\t>\r\n\t\t\t\t\t\t</upr-gds-address-field>\r\n\t\t\t\t\t\t<gds-spacer classes=\"spacer-50\" *ngIf=\"isUsCountry\"></gds-spacer>\r\n\t\t\t\t\t</ng-container>\r\n\r\n\t\t\t\t\t<!-- Zip -->\r\n\t\t\t\t\t<ng-container *ngSwitchCase=\"'zip'\">\r\n\t\t\t\t\t\t<upr-gds-address-field\r\n\t\t\t\t\t\t\t*ngIf=\"isUsCountry\"\r\n\t\t\t\t\t\t\t[id]=\"formElement.name\"\r\n\t\t\t\t\t\t\t(formReady)=\"addFormControl(formElement.name, $event)\"\r\n\t\t\t\t\t\t\t[country]=\"selectedCountry\"\r\n\t\t\t\t\t\t\t[state]=\"selectedState\"\r\n\t\t\t\t\t\t\t[formData]=\"formElement.data\"\r\n\t\t\t\t\t\t\t[isZipCodeMandiory]=\"formElement.required\"\r\n\t\t\t\t\t\t\t[useNativeStateDropdown]=\"true\"\r\n\t\t\t\t\t\t\t[theme]=\"theme\"\r\n\t\t\t\t\t\t>\r\n\t\t\t\t\t\t</upr-gds-address-field>\r\n\t\t\t\t\t\t<gds-spacer classes=\"spacer-50\" *ngIf=\"isUsCountry\"></gds-spacer>\r\n\t\t\t\t\t</ng-container>\r\n\r\n\t\t\t\t\t<!-- Button -->\r\n\t\t\t\t\t<gds-button\r\n\t\t\t\t\t\t*ngSwitchCase=\"'button'\"\r\n\t\t\t\t\t\t[theme]=\"theme\"\r\n\t\t\t\t\t\t[data]=\"formElement.data\"\r\n\t\t\t\t\t\t[id]=\"formElement.name\"\r\n\t\t\t\t\t\t(buttonClicked)=\"gdsButtonClicked(formElement.data.action)\"\r\n\t\t\t\t\t></gds-button>\r\n\r\n\t\t\t\t\t<!-- Spacer -->\r\n\t\t\t\t\t<gds-spacer\r\n\t\t\t\t\t\tclasses=\"spacer-50\"\r\n\t\t\t\t\t\t*ngIf=\"formElement.type !== 'state' && formElement.type !== 'zip'\"\r\n\t\t\t\t\t></gds-spacer>\r\n\t\t\t\t</ng-container>\r\n\t\t\t</ng-container>\r\n\t\t</div>\r\n\t</div>\r\n</ng-container>\r\n", styles: [".sr-only{position:absolute;width:1px;height:1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;clip-path:inset(50%);border:0}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.FormBuilder }, { type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: i2$1.FormControlService }, { type: GdsInputFormService }, { type: i4$1.PageLabelsResolver }]; } });

class GdsInputFormModule {
}
GdsInputFormModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsInputFormModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
GdsInputFormModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsInputFormModule, declarations: [GdsInputFormComponent,
        GdsInputFormCvaDirective], imports: [CommonModule, FormFieldsModule, FormsModule, ReactiveFormsModule], exports: [GdsInputFormComponent] });
GdsInputFormModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsInputFormModule, providers: [GdsInputFormService], imports: [[CommonModule, FormFieldsModule, FormsModule, ReactiveFormsModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsInputFormModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [GdsInputFormService],
                    declarations: [
                        GdsInputFormComponent,
                        GdsInputFormCvaDirective
                    ],
                    imports: [CommonModule, FormFieldsModule, FormsModule, ReactiveFormsModule],
                    exports: [
                        GdsInputFormComponent
                    ],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

export { GdsInputFormComponent, GdsInputFormModule, GdsInputFormService };
